export const FSC_TYPE_SLUGS = {
    ALL_IN: 'ALL_IN',
    VIA_INTEGRATION: 'VIA_INTEGRATION',
    FLAT_AMOUNT: 'FLAT_AMOUNT',
    FLAT_PERCENT: 'FLAT_PERCENT',
    VARIABLE_PERCENT: 'VARIABLE_PERCENT',
    VARIABLE_AMOUNT_PER_MILE: 'VARIABLE_AMOUNT_PER_MILE',
};
export const FSC_SOURCE_SLUGS = {
    CARGOMATIC: 'CARGOMATIC',
    REGIONAL: 'REGIONAL',
    CUSTOMER_SPECIFIC: 'CUSTOMER_SPECIFIC',
};
export const FSC_CALCULATION_FREQUENCY_SLUGS = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
};
export const FUEL_PRICE_WEEK_SLUGS = {
    CURRENT_WEEK: 'CURRENT_WEEK',
    PREVIOUS_WEEK: 'PREVIOUS_WEEK',
};
export const FSC_EFFECTIVE_DAY_SLUGS = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
};
export const FSC_IMPORT_ANCHOR_EVENTS_SLUGS = {
    TENDER_DATE: 'TENDER_DATE',
    LOADED_PICKUP_DATE: 'LOADED_PICKUP_DATE',
    LOADED_DELIVERY_DATE: 'LOADED_DELIVERY_DATE',
    EMPTY_RETURN_DATE: 'EMPTY_RETURN_DATE',
};
export const FSC_EXPORT_ANCHOR_EVENTS_SLUGS = {
    TENDER_DATE: 'TENDER_DATE',
    EMPTY_PICKUP_DATE: 'EMPTY_PICKUP_DATE',
    LOADED_PICKUP_DATE: 'LOADED_PICKUP_DATE',
    LOADED_DELIVERY_DATE: 'LOADED_DELIVERY_DATE',
};
export const FSC_REPOSITION_ANCHOR_EVENTS_SLUGS = {
    TENDER_DATE: 'TENDER_DATE',
    PICKUP_DATE: 'PICKUP_DATE',
    DELIVERY_DATE: 'DELIVERY_DATE',
};
